import React, { useRef } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";
import { secondsToHHMM, sumArrayOfObjects } from "../../Utilitie";

const CrewAvgTable = ({ data }) => {
  const tableRef = useRef();
  const filteredData = data?.filter(
    (obj) => obj.Lobby !== "[TOTAL]" && obj.Lobby !== "TOTAL",
  );

  const groupedData = filteredData?.reduce((acc, curr) => {
    const key = `${curr.Year}-${curr.Month_}`;

    if (!acc[key]) {
      acc[key] = {
        rows: [],
        totals: {},
      };
    }

    acc[key].rows.push(curr);

    // calculate totals
    Object.keys(curr).forEach((k) => {
      if (typeof curr[k] === "number") {
        acc[key].totals[k] = (acc[key].totals[k] || 0) + curr[k];
      }
    });

    return acc;
  }, {});
  return (
    <div className="newUiBody">
      <div
        className="table-responsive  p-0 m-0"
        style={{ maxHeight: "500px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-striped table-hover  "
          ref={tableRef}
        >
          <thead
            className="sticky-top text-center align-middle"
            style={{ zIndex: 2 }}
          >
            <tr className="table-dark" style={{ fontSize: "14px" }}>
              <th>SNO</th>
              <th>YEAR</th>
              <th>MONTH</th>
              <th>DIVISION</th>
              <th>LOBBY</th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                ON ROLL STRENGTH
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                HQ NORMAL REST
              </th>
              <th className="text-wrap" style={{ maxWidth: "100px" }}>
                HQ NORMAL OCCURENCE
              </th>
              <th className="text-wrap" style={{ maxWidth: "100px" }}>
                22 HRS REST
              </th>
              <th className="text-wrap" style={{ maxWidth: "100px" }}>
                22 HRS OCCURENCE
              </th>
              <th className="text-wrap" style={{ maxWidth: "100px" }}>
                30 HRS REST
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                30 HRS OCCURENCE
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                &gt; 30 HRS REST
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                &gt; 30 HRS OCCURENCE
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                HQ WOFF OCCURENCE
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                HQ CREW REST AT OUT STATION REST (LOBBY)
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                HQ CREW REST AT OUT STATION OCCURENCE (LOBBY)
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                HQ CREW REST AT OUT STATION (NON-LOBBY)
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                HQ CREW REST AT OUT STATION OCCURENCE (NON-LOBBY)
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                OUT STATION CREW AT HQREST
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                OUT STATION CREW AT HQ OCCURENCE
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                SISTER LOBBY REST
              </th>
              <th className="text-wrap" style={{ maxWidth: "120px" }}>
                20AT SISTER LOBBY OCCURENCE
              </th>
            </tr>
          </thead>
          <tbody>
            {groupedData &&
              Object.entries(groupedData).map(([key, value], groupIndex) => (
                <React.Fragment key={key}>
                  {value.rows.map((obj, ind) => (
                    <tr key={`${key}-${ind}`}>
                      <td>{ind + 1}</td>
                      <td>{obj.Year}</td>
                      <td>{obj.Month_}</td>
                      <td>{obj.Division}</td>
                      <td>{obj.Lobby}</td>
                      <td>{obj.ON_ROLL_STRENGTH}</td>
                      <td>{secondsToHHMM(obj.HQ_NORMAL_REST)}</td>
                      <td>{obj.HQ_NORMAL_OCCURENCE}</td>
                      <td>{secondsToHHMM(obj.HQ_PR_22_HRS_REST)}</td>
                      <td>{obj.HQ_PR_22_HR_OCCURENCE}</td>
                      <td>{secondsToHHMM(obj.HQ_PR_30_HRS_REST)}</td>
                      <td>{obj.HQ_PR_30_HRS_OCCURENCE}</td>
                      <td>{secondsToHHMM(obj.HQ_PR_30_HRS_REST)}</td>
                      <td>{obj["HQ_PR>30_HRS_OCCURENCE"]}</td>
                      <td>{obj.HQ_WOFF_OCCURENCE}</td>
                      <td>
                        {secondsToHHMM(
                          obj.HQ_CREW_REST_AT_OUT_STATION_REST_LOBBY,
                        )}
                      </td>
                      <td>{obj.HQ_CREW_REST_AT_OUT_STATION_LOBBY_OCCURANCE}</td>
                      <td>
                        {secondsToHHMM(
                          obj.HQ_CREW_REST_AT_OUT_STATION_REST_NON_LOBBY,
                        )}
                      </td>
                      <td>
                        {obj.HQ_CREW_REST_AT_OUT_STATION_NON_LOBBY_OCCURANCE}
                      </td>
                      <td>{secondsToHHMM(obj.OUT_STN_CREW_AT_HQ_REST)}</td>
                      <td>{obj.OUT_STN_CREW_AT_HQ_REST_OCCURENCE}</td>
                      <td>{secondsToHHMM(obj.HQ_SISTER_LOBBY)}</td>
                      <td>{obj.HQ_SISTER_LOBBY_OCCURENCE}</td>
                    </tr>
                  ))}

                  {/* Total Row */}
                  <tr className="table-dark fw-bold">
                    <td colSpan={4} className="text-center">
                      Total for {value.rows[0].Month_}
                    </td>
                    <td>-</td>
                    <td>{value.totals.ON_ROLL_STRENGTH}</td>
                    <td>{secondsToHHMM(value.totals.HQ_NORMAL_REST)}</td>
                    <td>{value.totals.HQ_NORMAL_OCCURENCE}</td>
                    <td>{secondsToHHMM(value.totals.HQ_PR_22_HRS_REST)}</td>
                    <td>{value.totals.HQ_PR_22_HR_OCCURENCE}</td>
                    <td>{secondsToHHMM(value.totals.HQ_PR_30_HRS_REST)}</td>
                    <td>{value.totals.HQ_PR_30_HRS_OCCURENCE}</td>
                    <td>{secondsToHHMM(value.totals.HQ_PR_30_HRS_REST)}</td>
                    <td>{value.totals["HQ_PR>30_HRS_OCCURENCE"]}</td>
                    <td>{value.totals.HQ_WOFF_OCCURENCE}</td>
                    <td>
                      {secondsToHHMM(
                        value.totals.HQ_CREW_REST_AT_OUT_STATION_REST_LOBBY,
                      )}
                    </td>
                    <td>
                      {value.totals.HQ_CREW_REST_AT_OUT_STATION_LOBBY_OCCURANCE}
                    </td>
                    <td>
                      {secondsToHHMM(
                        value.totals.HQ_CREW_REST_AT_OUT_STATION_REST_NON_LOBBY,
                      )}
                    </td>
                    <td>
                      {
                        value.totals
                          .HQ_CREW_REST_AT_OUT_STATION_NON_LOBBY_OCCURANCE
                      }
                    </td>
                    <td>
                      {secondsToHHMM(value.totals.OUT_STN_CREW_AT_HQ_REST)}
                    </td>
                    <td>{value.totals.OUT_STN_CREW_AT_HQ_REST_OCCURENCE}</td>
                    <td>{secondsToHHMM(value.totals.HQ_SISTER_LOBBY)}</td>
                    <td>{value.totals.HQ_SISTER_LOBBY_OCCURENCE}</td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`Crew Average Rest`} />
    </div>
  );
};
export default CrewAvgTable;
